import { render, staticRenderFns } from "./PopuActionSelect.vue?vue&type=template&id=10816e80&scoped=true&"
import script from "./PopuActionSelect.vue?vue&type=script&lang=js&"
export * from "./PopuActionSelect.vue?vue&type=script&lang=js&"
import style0 from "./PopuActionSelect.vue?vue&type=style&index=0&id=10816e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10816e80",
  null
  
)

export default component.exports